export default "__VITE_ASSET__WCU1bjY9__"